module.exports = __webpack_public_path__ + "img/Loading.5c6d66b7.svg";